export default __webpack_public_path__ + "static/media/member.f60941e0.png";